import { useContext } from 'react'
import { AuthenticationContext } from '../contexts/authenticationContext'

const useAuth = () => {
  return useContext(AuthenticationContext)
}

export default useAuth
